/**
 * 外部 API の消費量 API サービス
 *
 * 無料枠は Google Cloud プロジェクト単位なので、値はシステム全体の合計。
 */

import { apiClient } from '@/api/client'
import type { ApiUsageResponse } from '@/api/types/api-usage'

/** 今月の SKU ごとの消費量と上限 */
export const getApiUsage = async (): Promise<ApiUsageResponse> => {
  const res = await apiClient.get<ApiUsageResponse>('/api-usage')
  return res.data
}

/**
 * フロント側でしか数えられない SKU の利用を1件記録する。
 *
 * 記録に失敗しても画面の動作には影響しないので、呼び出し側では待たずに投げっぱなしでよい。
 */
export const sendApiUsageBeacon = async (sku: string): Promise<void> => {
  await apiClient.post('/api-usage/beacon', { sku })
}

/**
 * 地図の読み込み（Dynamic Maps）を1件記録する。
 *
 * 実際の課金イベントと完全には一致しない（マップの再利用など）ため推定値扱い。
 * 計測のしくじりで画面を壊さないよう、失敗は黙って無視する。
 */
export const sendMapLoadBeacon = (): void => {
  void sendApiUsageBeacon('dynamic_maps').catch(() => undefined)
}
